import { UIText2 } from '@cian/ui-kit/typography';
import * as React from 'react';

import * as styles from './Address.css';
import { OptionalAnchor } from '../../../../../common/components/OptionalAnchor';
import { IAddressDetail } from '../../../../../common/repositories/dailyrent/entities/address_detail/AddressDetail';
import { IGeoForMobileSite } from '../../../../../common/repositories/dailyrent/entities/geo_for_mobile_site/GeoForMobileSite';

const addressToString = (address: IAddressDetail[]) => {
  return address.map(unit => unit.value).join(', ');
};

export const Address = (props: Pick<IGeoForMobileSite, 'address' | 'title'>) => {
  const { address, title } = props;

  return (
    <>
      <UIText2 data-name="Address" color="text-secondary-default">
        {addressToString(address)}
      </UIText2>
      {title && (
        <OptionalAnchor href={title.link} rel="noopener" target="_blank" className={styles.link}>
          <UIText2 color={title.link ? 'primary_100' : 'text-secondary-default'}>{title.name}</UIText2>
        </OptionalAnchor>
      )}
    </>
  );
};
